import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import { useSite } from "@/context/SiteContext";

const Navbar = () => {
    const { content } = useSite();
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`sticky top-0 z-50 border-b transition-shadow duration-300 ${
                scrolled ? "border-slate-200 bg-white/90 shadow-sm backdrop-blur-xl" : "border-transparent bg-white/70 backdrop-blur-md"
            }`}
        >
            <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" aria-label="Main navigation">
                <a href="#top" data-testid="nav-logo-link" aria-label="Bangde Construction LLP — home">
                    <Logo />
                </a>

                <ul className="hidden items-center gap-8 md:flex">
                    {content.nav.map((item) => (
                        <li key={item.href}>
                            <a
                                href={item.href}
                                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-sm font-medium text-slate-600 transition-colors hover:text-navy"
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                </ul>

                <div className="hidden md:block">
                    <a
                        href="#contact"
                        data-testid="nav-book-call-button"
                        className="inline-flex items-center gap-2 rounded-xl bg-amberct px-5 py-2.5 text-sm font-bold text-navy shadow-sm transition-all hover:-translate-y-0.5 hover:bg-amber-400 hover:shadow-md"
                    >
                        Book a Call <ArrowRight className="h-4 w-4" />
                    </a>
                </div>

                <button
                    type="button"
                    data-testid="nav-mobile-toggle"
                    aria-label={open ? "Close menu" : "Open menu"}
                    aria-expanded={open}
                    onClick={() => setOpen(!open)}
                    className="rounded-lg p-2 text-navy hover:bg-slate-100 md:hidden"
                >
                    {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
            </nav>

            {open && (
                <div data-testid="nav-mobile-menu" className="border-t border-slate-200 bg-white px-4 pb-6 pt-2 md:hidden">
                    <ul className="flex flex-col gap-1">
                        {content.nav.map((item) => (
                            <li key={item.href}>
                                <a
                                    href={item.href}
                                    data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    onClick={() => setOpen(false)}
                                    className="block rounded-lg px-3 py-3 text-base font-medium text-slate-700 hover:bg-slate-50"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                    <a
                        href="#contact"
                        data-testid="nav-mobile-book-call-button"
                        onClick={() => setOpen(false)}
                        className="mt-3 flex items-center justify-center gap-2 rounded-xl bg-amberct px-5 py-3 text-sm font-bold text-navy"
                    >
                        Book a Free Discovery Call <ArrowRight className="h-4 w-4" />
                    </a>
                </div>
            )}
        </header>
    );
};

export default Navbar;
